import * as INR from "../INR.ts";
import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";
import ApiServer from "../ApiServer.js";
import FizConfig from "../FizConfig.js";
import * as libLocation from "../lib/location.ts";
import * as Confetti from "../lib/Confetti.js";
import * as Storage from "../lib/Storage.ts";
import * as OS from "../lib/os.js";
import deviceId from "../lib/deviceId.js";
import {openStorageAlert} from "../modal/storageAlert.js";
import * as ga from "../tracking-googleanalytics.js";

import * as FeatureSeen from "../util/FeatureSeen.js";
import { fwtrigger } from "../util/Html.ts";

INR.onPage(INR.URL.ENTER_HOME,function(){
  
  if(libLocation.getURLParam("modal")==="welcome"){
    libLocation.clearParamInHistory()
    import("../modal/welcome-invite.mustache").then(function(TPL_INVITE){
      
        import("../modal/welcome.mustache").then(function(TPL){
          Confetti.start(2000);
          modal.openModal(TPL).onClose = function(){
            setTimeout(function(){
              modal.openModal(TPL_INVITE).onClose = function(){
                Html.trigger('takepremium',['directclick'])
              }
            },200)
          }
        });  
      
    })
  }else if(libLocation.getURLParam("modal")==="promocode"){
    libLocation.clearParamInHistory()
    import("../modal/congratulations.mustache").then(function(TPL){
      Confetti.start(2000);
      modal.openModal(TPL)
    }); 
  }else if(libLocation.getURLParam("modal")==="premium"){
    setTimeout(()=>{
      Html.trigger('takepremium',['directclick'])
    },250);
  }else if(libLocation.getURLParam("from")==="2checkout"){
    
    Storage.sessionSet('waitingpremium',(new Date()).toISOString())
    
    import("../modal/waitingpremium.mustache").then(function(TPL){
      var 
        waitingModal = modal.openModal(TPL),
        pollCount = 0,
        interval = setInterval(function(){
        ApiServer.accgetstate(deviceId, "WebFirebase", FizConfig.jsVersion||"", function(accountState) {
          if(accountState.premium.fWPremiumMemberSubscriber){
            clearInterval(interval)
            modal.closeModal(waitingModal)
            premiumGetted()
          }else if(pollCount++>30){
            clearInterval(interval)
            modal.closeModal(waitingModal)
            modal.oops("modalcongratulations.waitingerror")
          }
          FwDatas.setState(accountState);
        },function(err){console.log(err)});
      },1000);
    })
    function premiumGetted(){
      import("../modal/congratulations.mustache").then(function(TPL){
        ga.event({
          'event': 'startedPremiumTrial',
          'form_name': 'premium trial form'
          });
        Confetti.start(2000);
        function displayDeepLink(data){
          modal.openModal(TPL,{deepLoginLink:data}).onClose = function(){libLocation.clearParamInHistory();}
        }
        function display(data){
          modal.openModal(TPL).onClose = function(){libLocation.clearParamInHistory();}
        }
        
        if(OS.hasApp){
          ApiServer.accdeeplink(OS.isAndroid?'home':'myfamily',displayDeepLink,display);
        }else{
          display()
        }
        
      });  
    }
      
  }else if(libLocation.getURLParam("result")==="200"){
    libLocation.clearParamInHistory();
    openStorageAlert(true)
    if(FwDatas.getState().premiumPopup && FwDatas.getState().premiumPopup.type==='PROMO_YEARLY_50'){
      Html.trigger('takepremium',['directclick'])
    }
  }
});

